import { RouterProvider } from '@tanstack/react-router';

import { router } from './router';
import './styles/App.scss';

function App() {
  return <RouterProvider router={router} />;
}

export default App;
